export const init = () => {
  /* SHOPPING TOOL - AddToCart */
  const shoppingTool =
    AnalyticsConstants.shoppingtool.tmp ||
    AnalyticsConstants.shoppingtool.actual;
  if (
    shoppingTool === undefined ||
    shoppingTool === null ||
    shoppingTool.st === undefined
  ) {
    // CLICK on 'add to cart' button
    Array.from(document.querySelectorAll('.cta-v2.dkti-cart')).forEach(
      element =>
        element.addEventListener('click', evt => {
          if (
            evt.target.closest('.list-last-viewed-products') &&
            evt.target.closest('.plv2-element')
          ) {
            const { productid, index } = evt.target.closest(
              '.plv2-element'
            ).dataset;
            CUBE.Analytics.shoppingtool.set(
              `merchandising-lvp`.trim(),
              `position-${index}`.trim()
            );
            CUBE.Analytics.shoppingtool.setTmp(
              `merchandising-lvp`.trim(),
              `position-${index}`.trim(),
              productid
            );
            CUBE.Analytics.shoppingtool.persist();
          }
        })
    );
  }
};



// WEBPACK FOOTER //
// ./src/analytics/shopping-tool/st-add-to-cart.js